"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSiteProductMenuApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class WebSiteProductMenuApi extends runtime.BaseAPI {
    /**
     * 商品分類選單設定-刪除選單
     */
    webSiteProductMenuDeleteDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ProductMenuEditViewModelToJSON)(requestParameters['productMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-刪除選單
     */
    webSiteProductMenuDeleteDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuDeleteDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-刪除產品
     */
    webSiteProductMenuDeleteProductMenuDetailDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/DeleteProductMenuDetail`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-刪除產品
     */
    webSiteProductMenuDeleteProductMenuDetailDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuDeleteProductMenuDetailDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    webSiteProductMenuGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    webSiteProductMenuGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.webSiteProductMenuGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-選單編輯頁查詢
     */
    webSiteProductMenuGetMenuByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/GetMenuById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-選單編輯頁查詢
     */
    webSiteProductMenuGetMenuByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuGetMenuByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-選單獲取
     */
    webSiteProductMenuGetMenuGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/GetMenu`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-選單獲取
     */
    webSiteProductMenuGetMenuGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuGetMenuGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-分頁查詢
     */
    webSiteProductMenuGetPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ProductMenuDetailSearchModelToJSON)(requestParameters['productMenuDetailSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-分頁查詢
     */
    webSiteProductMenuGetPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuGetPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-獲取商品
     */
    webSiteProductMenuGetProductMenuDetailGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/GetProductMenuDetail`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-獲取商品
     */
    webSiteProductMenuGetProductMenuDetailGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuGetProductMenuDetailGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-獲取可設定網站名稱
     */
    webSiteProductMenuGetWebSiteGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/GetWebSite`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-獲取可設定網站名稱
     */
    webSiteProductMenuGetWebSiteGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.webSiteProductMenuGetWebSiteGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-修改選單
     */
    webSiteProductMenuPatchPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/Patch`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ProductMenuEditViewModelToJSON)(requestParameters['productMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-修改選單
     */
    webSiteProductMenuPatchPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuPatchPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-修改選單商品
     */
    webSiteProductMenuPatchProductMenuDetailPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/PatchProductMenuDetail`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['productMenuDetailDualListItem'].map(index_1.ProductMenuDetailDualListItemToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-修改選單商品
     */
    webSiteProductMenuPatchProductMenuDetailPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuPatchProductMenuDetailPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-新增選單(下一層)
     */
    webSiteProductMenuPostNextPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/PostNext`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ProductMenuEditViewModelToJSON)(requestParameters['productMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-新增選單(下一層)
     */
    webSiteProductMenuPostNextPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuPostNextPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品分類選單設定-新增選單(同層)
     */
    webSiteProductMenuPostSamePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/WebSiteProductMenu/PostSame`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ProductMenuEditViewModelToJSON)(requestParameters['productMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品分類選單設定-新增選單(同層)
     */
    webSiteProductMenuPostSamePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.webSiteProductMenuPostSamePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.WebSiteProductMenuApi = WebSiteProductMenuApi;
